const getUri = (hostname) => {
  const isProd = Boolean(hostname === 'content.adireto.com');

  const uriProd = 'https://api.adireto.com/graphql';
  const uriStaging = 'https://api-staging.adireto.com/graphql';
  return isProd ? uriProd : uriStaging;
};

export { getUri };
